
import Button from "../Button";
import ResponsiveDialog from "../ResponsiveDialog";
import { PeopleProps } from "./access-people-table";


export type ShareProjectModalProps = {
    openRevokeAccessModal: boolean;
    setOpenRevokeAccessModal: (open: boolean) => void;
    selectedPerson: PeopleProps;
    onDelete: (id: string | number, role: string) => void;
    container?: HTMLElement | ShadowRoot | null,
}


export default function RevokeAccessModal({
    openRevokeAccessModal,
    setOpenRevokeAccessModal,
    selectedPerson,
    onDelete,
    container,
}: ShareProjectModalProps) {

    return (

        <ResponsiveDialog open={openRevokeAccessModal} onOpenChange={setOpenRevokeAccessModal} >
            <ResponsiveDialog.Content container={container} className="flex flex-col text-textcolor isolate max-w-[600px] p-6 bg-background" onOpenAutoFocus={(e: { preventDefault: () => any; }) => e.preventDefault()}>
                <ResponsiveDialog.Header>
                    <ResponsiveDialog.Title className="text-lg font-medium text-textcolor">Revoke Access</ResponsiveDialog.Title>
                </ResponsiveDialog.Header>
                <div className="text-sm">
                    Are you sure you want to revoke <span className="font-bold">{selectedPerson?.name}</span>'s access to this project?

                    This will remove them from all tasks and activities within this project.
                    <div className="text-destructive">This action cannot be undone.</div>
                </div>
                <ResponsiveDialog.Footer>
                    <Button variant="secondary" size="sm" onClick={() => setOpenRevokeAccessModal(false)}>Cancel</Button>
                    <Button
                        variant="destructive"
                        size="sm"
                        onClick={() => {
                            onDelete(selectedPerson.id, selectedPerson.role)
                            setOpenRevokeAccessModal(false)
                        }}>
                        Revoke Access
                    </Button>
                </ResponsiveDialog.Footer>
            </ResponsiveDialog.Content>

        </ResponsiveDialog>

    );
}